import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";

export default {
    name: "categoryDetail",
    components: {
        MainLayout
    },

    data() {
        return {
            category: {
                category_name: ''
            },
        };
    },

    methods: {
        getCategoryDetail() {
            axios.get("/category/detail/" + this.$route.params.id)
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log("Category Detail API Error", error);
                });
        }
    },

    created() {
        this.getCategoryDetail();
    }
};